// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2ey5a","errorLogs":"EditorFooter_errorLogs__y5czA"};